const organizationNorwegian = {
  common: {
    loading: "Laster...",
    error: "Det oppstod en feil",
    save: "Lagre",
    cancel: "Avbryt",
    yes: "Ja",
    no: "Nei"
  },
  header: {
    title: "Organisasjon",
    adminRole: "Administrator",
    employeeRole: "Ansatt",
    adminDescription: "Administrer din organisasjon, teammedlemmer og kundetildelinger",
    employeeDescription: "Se din organisasjon, teammedlemmer og kundetildelinger"
  },
  messages: {
    confirmRemoveMember: "Er du sikker på at du vil fjerne {email} fra organisasjonen?",
    confirmCancelInvitation: "Er du sikker på at du vil avbryte denne invitasjonen?",
    confirmCancelSubscription: "Er du sikker på at du vil si opp dette abonnementet?"
  },
  notifications: {
    success: {
      invitationSent: "Invitasjon sendt til {email}",
      memberRemoved: "Medlem fjernet fra organisasjonen",
      invitationCancelled: "Invitasjon kansellert",
      customerAssigned: "Kunde tildelt til ansatt",
      assignmentRemoved: "Kundetildeling fjernet",
      licenseAdded: "Lisenser lagt til"
    },
    error: {
      general: "Det oppstod en feil",
      emailRequired: "Vennligst oppgi en e-post",
      noOrganization: "Ingen organisasjon funnet",
      memberExists: "Denne brukeren er allerede medlem av organisasjonen",
      invitationExists: "Denne brukeren er allerede invitert til organisasjonen",
      billingPortal: "Det oppstod en feil ved åpning av kundeportalen. Prøv igjen senere."
    }
  },
  subscription: {
    card: {
      title: "LinkedIn Poster-lisenser",
      status: {
        active: "Aktiv",
        trialing: "Prøveperiode",
        inactive: "Inaktiv"
      },
      currentPlan: "Nåværende plan:",
      noPlan: "Ingen plan",
      licenseInfo: {
        total: "Totale lisenser",
        assigned: "Tildelte lisenser",
        available: "Tilgjengelige lisenser"
      },
      trial: {
        info: "Din prøveperiode utløper om"
      },
      actions: {
        addLicenses: "Legg til lisenser",
        manageBilling: "Administrer betaling"
      }
    }
  },
  team: {
    card: {
      title: "Team",
      inviteButton: "Inviter medlem",
      emptyState: {
        admin: "Ditt team er tomt. Inviter teammedlemmer ved å klikke på \"Inviter medlem\"-knappen.",
        employee: "Det er ingen teammedlemmer i organisasjonen ennå."
      },
      memberInfo: {
        you: "(Deg)",
        admin: "Administrator",
        member: "Medlem",
        status: {
          active: "Aktiv",
          invited: "Invitert"
        },
        invitationBadge: "Invitasjon"
      }
    }
  },
  customerManagement: {
    card: {
      title: "Kundehåndtering",
      adminSubheader: "Tildel kunder til ansatte",
      employeeSubheader: "Oversikt over kunder og tildelinger",
      emptyState: {
        admin: "Det er ingen kunder i organisasjonen ennå. Inviter kunder ved å velge \"Kunde\" i invitasjonsskjemaet.",
        employee: "Det er ingen kunder i organisasjonen ennå."
      },
      tableHeaders: {
        customer: "Kunde",
        email: "E-post",
        status: "Status",
        assignedTo: "Tildelt til",
        actions: "Handlinger"
      },
      status: {
        active: "Aktiv",
        invited: "Invitert"
      },
      notAssigned: "Ikke tildelt",
      actions: {
        assign: "Tildel kunde",
        removeAssignment: "Fjern tildeling"
      }
    }
  },
  modals: {
    assignLicense: {
      title: "Tildel lisens",
      email: "E-post",
      licenseType: "Lisenstype",
      availableLicenses: "Tilgjengelige lisenser:",
      licenseTypes: {
        basic: "Basic",
        pro: "Professional",
        enterprise: "Enterprise"
      }
    },
    updateSubscription: {
      title: "Oppdater abonnement",
      quantity: "Antall lisenser",
      preview: {
        plan: "Plan:",
        pricePerLicense: "Pris per lisens:",
        total: "Total:"
      }
    },
    inviteMember: {
      title: "Inviter teammedlem",
      email: "E-post",
      emailPlaceholder: "Skriv inn teammedlemmets e-post",
      role: "Rolle",
      roles: {
        employee: "Ansatt (Kan administrere egne og andres profiler)",
        customer: "Kunde (Kan kun logge inn med LinkedIn)"
      },
      info: "En invitasjon vil bli sendt til denne e-postadressen. Når brukeren aksepterer invitasjonen, vil de få tildelt en lisens.",
      employeeInfo: " Som ansatt kan de administrere både egne og andres LinkedIn-profiler.",
      customerInfo: " Som kunde kan de kun logge inn med LinkedIn og vil ikke ha tilgang til dashbordet.",
      availableLicenses: "Tilgjengelige lisenser:",
      sending: "Sender invitasjon...",
      send: "Send invitasjon"
    },
    buyLicense: {
      title: "Kjøp flere lisenser",
      info: "Du må kjøpe flere lisenser for å kunne invitere flere medlemmer. Du har for øyeblikket {currentLicenses} lisens(er).",
      quantity: "Antall lisenser å legge til",
      pricing: {
        info: "Hver lisens gir én plass til et teammedlem",
        price: "Pris: 1490 kr ekskl. mva/md. per lisens (Det er mulighet for å skrive inn en rabattkode)",
        total: "Total: {total} kr ekskl. mva/md."
      },
      buy: "Kjøp lisenser"
    },
    assignCustomer: {
      title: "Tildel kunde: {customerName}",
      selectEmployee: "Velg ansatt",
      noEmployee: "Velg ansatt",
      assign: "Tildel kunde"
    }
  }
};

export default organizationNorwegian; 